import styles from './Servers.module.css';

import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader, Card, Spin, Button, List, Tag } from 'antd';

import {
  ReloadOutlined
} from '@ant-design/icons';

import {
  getServicesHealth
} from 'store/ducks/health.js';

const getResponseTimeColor = (ms) => {
  if (ms <= 100) {
    return 'green';
  } else if (ms > 100 && ms <= 200) {
    return 'orange';
  } else if (ms > 200 && ms <= 300) {
    return 'volcano';
  } else {
    return 'red';
  }
};

const Servers = () => {
  const dispatch = useDispatch();

  const servicesHealth = useSelector(state => state.health.servicesHealth);
  const loading = useSelector(state => state.health.getServicesHealth.loading);

  const reload = () => dispatch(getServicesHealth());

  return (
    <>
      <PageHeader
        title="Servers"
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
        extra={[
          <Button onClick={() => reload()}><ReloadOutlined /></Button>
        ]}
      />

      <Spin spinning={loading} size="large">
        <Card style={{ width: '100%', minHeight: 224, padding: '40px 0 0 0' }}>

          <List header="Services Health" >
            {servicesHealth && servicesHealth.map((service) =>
              <List.Item key={service._id}>
                <List.Item.Meta
                  avatar={<div className={[styles.status ,service.online ? styles.online : styles.offline].join(' ')} />}
                  title={service.name}
                />
                <div><Tag color={getResponseTimeColor(service.responseTime)}>{service.responseTime}ms</Tag></div>
              </List.Item>
            )}
          </List>


        </Card>
      </Spin>
    </>
  );
}

export default Servers;
